import { formatDistance } from "date-fns";
import { useLanguage } from "./useLanguage";
import { computed } from "vue";
import { enGB, fr } from "date-fns/locale";

export const useDates = () => {
  const { language } = useLanguage();

  const locale = computed(() => {
    switch (language.value) {
      case "fr":
        return fr;
      case "en":
        return enGB;
      default:
        return fr;
    }
  });

  function formatDistanceToNow(date: string | Date, addSuffix = true): string {
    return formatDistance(new Date(date), new Date(), {
      addSuffix,
      locale: locale.value,
    });
  }

  return { formatDistanceToNow };
};
